var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_743_293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9762 0L15.3648 8.82348H7.89062L11.211 0H18.9762Z",
    fill: "#AB322F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.71 7.30176H7.61413C7.08498 7.30176 6.64844 7.7383 6.64844 8.26745V13.4266H16.6757V8.26745C16.6757 7.72507 16.2392 7.30176 15.71 7.30176ZM15.9614 9.19345H7.17758V8.79659C7.17758 8.37327 7.52153 8.0161 7.95807 8.0161H15.1941C15.6174 8.0161 15.9746 8.36005 15.9746 8.79659V9.19345H15.9614Z",
    fill: "#FFDC01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.39844 0L7.89079 8.82348H15.365L11.9652 0H4.39844Z",
    fill: "#FA352C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.62289 8.82348L5.79983 0H5.36328L9.18635 8.82348H9.62289Z",
    fill: "#FCE0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.2362 8.82348L7.41311 0H6.97656L10.7996 8.82348H11.2362Z",
    fill: "#FCE0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.0237 8.82348L9.20066 0H8.77734L12.6004 8.82348H13.0237Z",
    fill: "#FCE0E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.6112 8.82348L10.7881 0H10.3516L14.1746 8.82348H14.6112Z",
    fill: "#FCE0E0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.1734 25.9883C23.8591 20.617 21.682 14.0855 16.3106 11.3998C10.9393 8.71418 4.40785 10.8913 1.72219 16.2627C-0.963469 21.634 1.21369 28.1654 6.585 30.8511C11.9563 33.5368 18.4878 31.3596 21.1734 25.9883Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20.1937 14.6572C21.2916 16.3505 21.9266 18.3745 21.9266 20.544C21.9266 26.5497 17.0585 31.4179 11.0527 31.4179C7.46775 31.4179 4.29288 29.6849 2.30859 27.0127C4.23997 30.0156 7.61327 31.9999 11.4496 31.9999C17.4553 31.9999 22.3235 27.1318 22.3235 21.126C22.3235 18.7052 21.5298 16.4695 20.1937 14.6572Z",
    fill: "#FFDC01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M19.3766 25.0889C21.5657 20.7108 19.7911 15.3871 15.413 13.198C11.0349 11.009 5.71124 12.7836 3.5222 17.1617C1.33316 21.5397 3.10773 26.8634 7.48581 29.0525C11.8639 31.2415 17.1876 29.4669 19.3766 25.0889Z",
    fill: "#FFDC01"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M10.3631 27.1582C10.7071 27.436 10.7997 27.8858 10.7997 27.8858C10.7997 27.8858 10.3367 27.899 9.97951 27.6212C9.63557 27.3434 9.54297 26.8937 9.54297 26.8937C9.54297 26.8937 10.0192 26.8804 10.3631 27.1582Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M9.93877 27.8729C10.3621 27.7274 10.7986 27.8862 10.7986 27.8862C10.7986 27.8862 10.5605 28.283 10.1372 28.4285C9.71389 28.5741 9.27734 28.4153 9.27734 28.4153C9.27734 28.4153 9.52869 28.0185 9.93877 27.8729Z",
    fill: "#FFF375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.01726 26.7874C9.32152 27.1049 9.34797 27.5679 9.34797 27.5679C9.34797 27.5679 8.88497 27.515 8.58072 27.1975C8.27646 26.88 8.25 26.417 8.25 26.417C8.25 26.417 8.713 26.4699 9.01726 26.7874Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M8.50101 27.4355C8.93755 27.3429 9.34764 27.5677 9.34764 27.5677C9.34764 27.5677 9.05661 27.9249 8.62007 28.0175C8.18352 28.1101 7.77344 27.8852 7.77344 27.8852C7.77344 27.8852 8.06447 27.5281 8.50101 27.4355Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M7.94404 26.2707C8.19539 26.6279 8.14247 27.0909 8.14247 27.0909C8.14247 27.0909 7.6927 26.9718 7.44136 26.6014C7.19001 26.2443 7.24293 25.7812 7.24293 25.7812C7.24293 25.7812 7.6927 25.9003 7.94404 26.2707Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M7.33669 26.8266C7.78646 26.8134 8.15686 27.0912 8.15686 27.0912C8.15686 27.0912 7.81292 27.4087 7.36314 27.4219C6.91337 27.4351 6.54297 27.1573 6.54297 27.1573C6.54297 27.1573 6.88691 26.8399 7.33669 26.8266Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M6.95037 25.4641C7.10912 25.8742 6.95037 26.3107 6.95037 26.3107C6.95037 26.3107 6.54029 26.0858 6.39477 25.6757C6.23603 25.2656 6.39477 24.8291 6.39477 24.8291C6.39477 24.8291 6.79163 25.054 6.95037 25.4641Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M6.22554 25.8612C6.66208 25.9538 6.95311 26.311 6.95311 26.311C6.95311 26.311 6.54302 26.5359 6.10648 26.4433C5.66994 26.3507 5.37891 25.9935 5.37891 25.9935C5.37891 25.9935 5.78899 25.7686 6.22554 25.8612Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M6.19754 24.5382C6.25046 24.9748 5.98589 25.3584 5.98589 25.3584C5.98589 25.3584 5.64194 25.0409 5.58903 24.6044C5.53611 24.1678 5.80069 23.7842 5.80069 23.7842C5.80069 23.7842 6.14463 24.1017 6.19754 24.5382Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M5.39111 24.7503C5.78797 24.9355 5.9864 25.3588 5.9864 25.3588C5.9864 25.3588 5.53662 25.4779 5.12654 25.2927C4.72968 25.1075 4.53125 24.6842 4.53125 24.6842C4.53125 24.6842 4.99425 24.5651 5.39111 24.7503Z",
    fill: "#FFF375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M5.5635 23.3607C5.52382 23.7972 5.1931 24.1279 5.1931 24.1279C5.1931 24.1279 4.92853 23.7443 4.95498 23.321C4.99467 22.8844 5.32539 22.5537 5.32539 22.5537C5.32539 22.5537 5.58996 22.9241 5.5635 23.3607Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M4.73033 23.4137C5.0875 23.6782 5.19333 24.128 5.19333 24.128C5.19333 24.128 4.73033 24.1545 4.37316 23.8899C4.01599 23.6253 3.91016 23.1755 3.91016 23.1755C3.91016 23.1755 4.37316 23.1491 4.73033 23.4137Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M5.23039 22.2494C5.12456 22.6727 4.74093 22.9505 4.74093 22.9505C4.74093 22.9505 4.52927 22.5404 4.6351 22.1171C4.74093 21.6938 5.12456 21.416 5.12456 21.416C5.12456 21.416 5.33622 21.8261 5.23039 22.2494Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M4.39768 22.1707C4.70193 22.4881 4.74162 22.9511 4.74162 22.9511C4.74162 22.9511 4.27862 22.8982 3.96113 22.594C3.65687 22.2765 3.61719 21.8135 3.61719 21.8135C3.61719 21.8135 4.08019 21.8532 4.39768 22.1707Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M5.19322 21.0063C4.98156 21.3899 4.54502 21.5619 4.54502 21.5619C4.54502 21.5619 4.45242 21.1121 4.65085 20.7285C4.86251 20.3448 5.29905 20.1729 5.29905 20.1729C5.29905 20.1729 5.40488 20.6226 5.19322 21.0063Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M4.39768 20.7284C4.62256 21.112 4.54319 21.5618 4.54319 21.5618C4.54319 21.5618 4.10665 21.403 3.88176 21.0326C3.65688 20.649 3.73625 20.1992 3.73625 20.1992C3.73625 20.1992 4.18602 20.358 4.39768 20.7284Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M5.41809 19.7498C5.12706 20.0805 4.66406 20.1466 4.66406 20.1466C4.66406 20.1466 4.67729 19.6836 4.96832 19.3529C5.25935 19.0222 5.72235 18.9561 5.72235 18.9561C5.72235 18.9561 5.70912 19.4191 5.41809 19.7498Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M4.71347 19.2997C4.84576 19.723 4.64733 20.1463 4.64733 20.1463C4.64733 20.1463 4.25047 19.8949 4.13141 19.4716C3.99912 19.0483 4.19755 18.625 4.19755 18.625C4.19755 18.625 4.58118 18.8896 4.71347 19.2997Z",
    fill: "#FFF375"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M5.86465 18.7181C5.50748 18.9694 5.03125 18.9297 5.03125 18.9297C5.03125 18.9297 5.15031 18.4799 5.50748 18.2286C5.86465 17.9772 6.34088 18.0169 6.34088 18.0169C6.34088 18.0169 6.22182 18.4667 5.86465 18.7181Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M5.28456 18.1227C5.31102 18.5593 5.03322 18.9297 5.03322 18.9297C5.03322 18.9297 4.71573 18.599 4.68928 18.1624C4.66282 17.7259 4.94062 17.3555 4.94062 17.3555C4.94062 17.3555 5.25811 17.6862 5.28456 18.1227Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M6.43408 17.7792C6.03722 17.9777 5.57422 17.8586 5.57422 17.8586C5.57422 17.8586 5.75942 17.4353 6.15628 17.2369C6.55314 17.0384 7.01614 17.1575 7.01614 17.1575C7.01614 17.1575 6.83094 17.594 6.43408 17.7792Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M5.96023 17.1044C5.92054 17.5409 5.5766 17.8584 5.5766 17.8584C5.5766 17.8584 5.31203 17.4748 5.35171 17.0382C5.3914 16.6017 5.73534 16.2842 5.73534 16.2842C5.73534 16.2842 5.99991 16.681 5.96023 17.1044Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M12.7725 27.1045C12.4285 27.3823 12.3359 27.8321 12.3359 27.8321C12.3359 27.8321 12.7989 27.8453 13.1561 27.5675C13.5001 27.2897 13.5927 26.8399 13.5927 26.8399C13.5927 26.8399 13.1164 26.8267 12.7725 27.1045Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M13.1958 27.8056C12.7725 27.66 12.3359 27.8188 12.3359 27.8188C12.3359 27.8188 12.5741 28.2156 12.9974 28.3612C13.4207 28.5067 13.8572 28.3479 13.8572 28.3479C13.8572 28.3479 13.6059 27.9511 13.1958 27.8056Z",
    fill: "#FFF375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M13.9479 26.7874C13.6436 27.1049 13.6172 27.5679 13.6172 27.5679C13.6172 27.5679 14.0802 27.515 14.3844 27.1975C14.6887 26.88 14.7152 26.417 14.7152 26.417C14.7152 26.417 14.2522 26.4699 13.9479 26.7874Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M14.4638 27.4364C14.0273 27.3438 13.6172 27.5687 13.6172 27.5687C13.6172 27.5687 13.9082 27.9259 14.3448 28.0185C14.7813 28.1111 15.1914 27.8862 15.1914 27.8862C15.1914 27.8862 14.9004 27.529 14.4638 27.4364Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M15.0195 26.219C14.7681 26.5761 14.8211 27.0391 14.8211 27.0391C14.8211 27.0391 15.2708 26.9201 15.5222 26.5497C15.7735 26.1925 15.7206 25.7295 15.7206 25.7295C15.7206 25.7295 15.2708 25.8618 15.0195 26.219Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M15.6288 26.7749C15.179 26.7616 14.8086 27.0394 14.8086 27.0394C14.8086 27.0394 15.1525 27.3569 15.6023 27.3702C16.0521 27.3834 16.4225 27.1056 16.4225 27.1056C16.4225 27.1056 16.0653 26.8013 15.6288 26.7749Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M15.9729 25.4387C15.8142 25.8488 15.9729 26.2853 15.9729 26.2853C15.9729 26.2853 16.383 26.0604 16.5285 25.6503C16.6872 25.2403 16.5285 24.8037 16.5285 24.8037C16.5285 24.8037 16.1316 25.0286 15.9729 25.4387Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M16.7119 25.8358C16.2754 25.9284 15.9844 26.2856 15.9844 26.2856C15.9844 26.2856 16.3945 26.5105 16.831 26.4179C17.2676 26.3253 17.5586 25.9681 17.5586 25.9681C17.5586 25.9681 17.1353 25.7432 16.7119 25.8358Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M16.7648 24.4464C16.7119 24.883 16.9765 25.2666 16.9765 25.2666C16.9765 25.2666 17.3204 24.9491 17.3733 24.5126C17.4262 24.076 17.1617 23.6924 17.1617 23.6924C17.1617 23.6924 16.8177 24.0099 16.7648 24.4464Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M17.5718 24.6585C17.175 24.8437 16.9766 25.267 16.9766 25.267C16.9766 25.267 17.4263 25.3861 17.8364 25.2009C18.2333 25.0157 18.4317 24.5924 18.4317 24.5924C18.4317 24.5924 17.9687 24.4733 17.5718 24.6585Z",
    fill: "#FFF375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M17.3359 23.348C17.3756 23.7845 17.7063 24.1152 17.7063 24.1152C17.7063 24.1152 17.9709 23.7316 17.9444 23.3083C17.9047 22.8717 17.574 22.541 17.574 22.541C17.574 22.541 17.2962 22.9114 17.3359 23.348Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M18.17 23.3876C17.8129 23.6522 17.707 24.102 17.707 24.102C17.707 24.102 18.17 24.1285 18.5272 23.8639C18.8844 23.5993 18.9902 23.1495 18.9902 23.1495C18.9902 23.1495 18.5272 23.1363 18.17 23.3876Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M17.6664 22.224C17.7722 22.6473 18.1558 22.9251 18.1558 22.9251C18.1558 22.9251 18.3675 22.5151 18.2616 22.0917C18.1558 21.6684 17.7722 21.3906 17.7722 21.3906C17.7722 21.3906 17.5605 21.8007 17.6664 22.224Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M18.5002 22.1443C18.1959 22.4618 18.1562 22.9248 18.1562 22.9248C18.1562 22.9248 18.6193 22.8719 18.9367 22.5676C19.241 22.2501 19.2807 21.7871 19.2807 21.7871C19.2807 21.7871 18.8045 21.8268 18.5002 22.1443Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M17.7065 21.0199C17.9182 21.4036 18.3547 21.5755 18.3547 21.5755C18.3547 21.5755 18.4473 21.1258 18.2489 20.7421C18.0372 20.3585 17.6007 20.1865 17.6007 20.1865C17.6007 20.1865 17.4948 20.6363 17.7065 21.0199Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M18.4872 20.7557C18.2623 21.1393 18.3417 21.5891 18.3417 21.5891C18.3417 21.5891 18.7783 21.4304 19.0031 21.06C19.228 20.6763 19.1487 20.2266 19.1487 20.2266C19.1487 20.2266 18.7121 20.3721 18.4872 20.7557Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M17.4683 19.7634C17.7593 20.0942 18.2224 20.1603 18.2224 20.1603C18.2224 20.1603 18.2091 19.6973 17.9181 19.3666C17.6271 19.0359 17.1641 18.9697 17.1641 18.9697C17.1641 18.9697 17.1773 19.446 17.4683 19.7634Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M18.1705 19.3133C18.0382 19.7366 18.2366 20.16 18.2366 20.16C18.2366 20.16 18.6335 19.9086 18.7525 19.4853C18.8848 19.062 18.6864 18.6387 18.6864 18.6387C18.6864 18.6387 18.2895 18.9032 18.1705 19.3133Z",
    fill: "#FFF375"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M17.0309 18.7581C17.3881 19.0094 17.8643 18.9697 17.8643 18.9697C17.8643 18.9697 17.7453 18.52 17.3881 18.2686C17.0309 18.0173 16.5547 18.057 16.5547 18.057C16.5547 18.057 16.6605 18.5067 17.0309 18.7581Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M17.5994 18.1628C17.573 18.5993 17.8508 18.9697 17.8508 18.9697C17.8508 18.9697 18.1683 18.639 18.1947 18.2025C18.2212 17.7659 17.9434 17.3955 17.9434 17.3955C17.9434 17.3955 17.6259 17.7262 17.5994 18.1628Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M16.4219 17.832C16.8188 18.0304 17.2818 17.9113 17.2818 17.9113C17.2818 17.9113 17.0966 17.488 16.6997 17.2896C16.3028 17.0912 15.8398 17.2102 15.8398 17.2102C15.8398 17.2102 16.025 17.6335 16.4219 17.832Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M16.8986 17.1571C16.9383 17.5936 17.2822 17.9111 17.2822 17.9111C17.2822 17.9111 17.5468 17.5275 17.5071 17.0909C17.4674 16.6544 17.1235 16.3369 17.1235 16.3369C17.1235 16.3369 16.8589 16.7205 16.8986 17.1571Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M16.106 16.4961C16.0928 16.5093 16.0663 16.5358 16.0399 16.549C16.0266 16.549 16.0266 16.5622 16.0134 16.5622C17.4024 17.7528 18.2755 19.4593 18.2755 21.3642C18.2755 24.9359 15.2065 27.833 11.4231 27.833C7.63971 27.833 4.57067 24.9359 4.57067 21.3642C4.57067 19.5387 5.37762 17.8983 6.66079 16.721C6.62111 16.7078 6.58142 16.6945 6.55496 16.6813C5.27179 17.8719 4.46484 19.5387 4.46484 21.3642C4.46484 24.9889 7.58679 27.9388 11.4231 27.9388C15.2594 27.9388 18.3813 24.9889 18.3813 21.3642C18.3946 19.4328 17.5083 17.6999 16.106 16.4961Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M7.36226 16.959C6.92571 17.0516 6.51562 16.84 6.51562 16.84C6.51562 16.84 6.80665 16.4696 7.2432 16.377C7.67974 16.2844 8.08983 16.496 8.08983 16.496C8.08983 16.496 7.78557 16.8664 7.36226 16.959Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M7.05602 16.1914C6.91051 16.6014 6.50042 16.8396 6.50042 16.8396C6.50042 16.8396 6.34168 16.403 6.48719 15.9929C6.63271 15.5828 7.0428 15.3447 7.0428 15.3447C7.0428 15.3447 7.21477 15.7813 7.05602 16.1914Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M15.5479 16.959C15.9844 17.0516 16.3945 16.84 16.3945 16.84C16.3945 16.84 16.1035 16.4696 15.6669 16.377C15.2304 16.2844 14.8203 16.496 14.8203 16.496C14.8203 16.496 15.1113 16.8664 15.5479 16.959Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M15.8388 16.1914C15.9843 16.6014 16.3944 16.8396 16.3944 16.8396C16.3944 16.8396 16.5531 16.403 16.4076 15.9929C16.2621 15.5828 15.852 15.3447 15.852 15.3447C15.852 15.3447 15.6932 15.7813 15.8388 16.1914Z",
    fill: "#FFF375"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M11.0666 17.2373H12.6011V24.6056H10.802V19.2216L9.43949 20.1608L8.56641 18.8909L11.0666 17.2373Z",
    fill: "#AD790D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7478,
    height: 32,
    fill: "white",
    transform: "translate(0.574219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBadgeIcon);
export default __webpack_public_path__ + "static/media/goldBadgeIcon.f499c8080abf46d3b399774ff4708550.svg";
export { ForwardRef as ReactComponent };